import {ThreeBottomUnit} from '../ThreeBottomUnit';
import {ThreeBottomCorpus} from '../../../details/ThreeCorpus/types/ThreeBottomCorpus';
import {KitchenService} from '../../../../../services/KitchenService/KitchenService';
import {ISaveBottomUnitData} from '../../../../../../../common-code/interfaces/saveData/ISaveBottomUnitData';
import {ISaveCorpusData} from '../../../../../../../common-code/interfaces/saveData/ISaveCorpusData';
import {CommonHelper} from 'common-code';

export class ThreeBottomUnitNormal extends ThreeBottomUnit {
    corpus: ThreeBottomCorpus;

    constructor(options: ISaveBottomUnitData, service: KitchenService) {
        super(options, service);
        this.corpus = this.initCorpus(options.corpus);
    }

    protected initCorpus(corpusData: ISaveCorpusData): ThreeBottomCorpus {
        return new ThreeBottomCorpus(CommonHelper.deepCopy(corpusData), this)
    }
}